import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { SalesPaymentForm } from "@/features/sales-payments";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const CreateSalesPayment = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("sales-payments", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal membuat pembayaran penjualan");
      showSnackbar(errorMessage);
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Penerimaan Penjualan"
      breadcrumbs={[
        { title: "Penerimaan Penjualan", path: "/sales/sales-payments" },
        { title: "Buat" },
      ]}
    >
      <SalesPaymentForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
